import { createSlice } from '@reduxjs/toolkit';

const consultationSlice = createSlice({
    name: 'consultation',
    initialState: {},
    reducers: {
        updateConsultation: (state, action) => {
            const { conversationID, object } = action.payload;
            return {
                ...state,
                [conversationID]: { ...state[conversationID], ...object }
            };
        },
        removeConsultation: (state, action) => {
            const { conversationID } = action.payload;
            delete state[conversationID];
        },
        removeForm: (state, action) => {
            const { conversationID, formName } = action.payload;
            if (state[conversationID]) {
                delete state[conversationID][formName];
            }
        }
    }
});

export const { updateConsultation, removeConsultation, removeForm } = consultationSlice.actions;
export default consultationSlice.reducer;